import { SubscriptionStatus } from "client/api-v2";

export type SubscriptionStatusColor = "default" | "success" | "error" | "warning";

// A Record rather than a switch so a status added to the contract fails to compile here instead of
// quietly rendering grey.
const SUBSCRIPTION_STATUS_COLOR: Record<SubscriptionStatus, SubscriptionStatusColor> = {
  [SubscriptionStatus.Pending]: "warning",
  [SubscriptionStatus.Active]: "success",
  [SubscriptionStatus.Expired]: "error",
  [SubscriptionStatus.Canceled]: "default",
};

function isSubscriptionStatus(value: string | undefined): value is SubscriptionStatus {
  return value !== undefined && value in SUBSCRIPTION_STATUS_COLOR;
}

// Status is optional on some subscription DTOs, and the grids substitute "Unknown" for a missing one,
// so anything off the contract falls back rather than failing a lookup.
export function subscriptionStatusColor(status: SubscriptionStatus | string | undefined): SubscriptionStatusColor {
  return isSubscriptionStatus(status) ? SUBSCRIPTION_STATUS_COLOR[status] : "default";
}
